import gql from 'graphql-tag';

export const SLURM_LATEST_COMMAND_QUERY = gql`
  query SlurmLatestCommand(
    $projectName: String!
    $entityName: String!
    $runName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        slurmControl {
          latestCommand {
            __typename
            id
            command
            state
            errorMessage
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

export const SLURM_DAEMON_READINESS_QUERY_BY_RUN_NAME = gql`
  query SlurmDaemonReadinessByRunName(
    $projectName: String!
    $entityName: String!
    $runName: String!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        slurmControl {
          health {
            ready
            lastSeenAt
            message
          }
        }
      }
    }
  }
`;
